import { Flex, Grid } from '@aloft/toolkit-sui';

import { SiteSizeVsCostPerSFChartUnwrapped } from '../../components/SiteValueCharts/SiteSizeVsCostPerSFChart.tsx';
import { SiteSizeVsSiteValueChartUnwrapped } from '../../components/SiteValueCharts/SiteSizeVsSiteValueChart.tsx';
import { SiteToValueRatioChartUnwrapped } from '../../components/SiteValueCharts/SiteToValueRatioChart.tsx';
import { Typography } from '../../summary/components/Typography.tsx';
import { useTkv2SiteValueChartsParams } from './utils/useTkv2SiteValueChartsParams.ts';

export const Tkv2SiteValueCharts = ({ isPopout }: { isPopout: boolean }) => {
  const params = useTkv2SiteValueChartsParams();

  const {
    siteSizeVsSiteValueChartData,
    siteSizeVsPriceChartData,
    siteToValueRatioChartData,
    publicRecordsIsLoading,
  } = params;

  return (
    <Grid
      gridTemplateColumns="repeat(auto-fit, minmax(36rem, 1fr))"
      width="100%"
      justifyContent="center"
      gap={isPopout ? '3rem' : '1rem'}
      margin="1rem"
      paddingX="1rem"
      paddingTop={isPopout ? '2rem' : 0}
    >
      {siteSizeVsSiteValueChartData && (
        <Flex className="reference-view-site-analysis-container">
          <Typography variant="h3">Site Size vs Site Value</Typography>
          <SiteSizeVsSiteValueChartUnwrapped data={siteSizeVsSiteValueChartData} />
        </Flex>
      )}
      {siteSizeVsPriceChartData && (
        <Flex className="reference-view-site-analysis-container">
          <Typography variant="h3">Site Size vs $ / SF</Typography>
          <SiteSizeVsCostPerSFChartUnwrapped data={siteSizeVsPriceChartData} />
        </Flex>
      )}
      {siteToValueRatioChartData && (
        <Flex className="reference-view-site-analysis-container">
          <Typography variant="h3">Site to Value Ratio</Typography>
          <SiteToValueRatioChartUnwrapped
            data={siteToValueRatioChartData}
            isLoading={publicRecordsIsLoading}
          />
        </Flex>
      )}
    </Grid>
  );
  // );
};
